var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarageFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H16.4286V10.8H8.57143V18H7V9.2L12.5 6L18 9.2V18ZM9.35714 11.6H15.6429V13.2H9.35714V11.6ZM9.35714 14H15.6429V15.6H9.35714V14ZM15.6429 16.4V18H9.35714V16.4H15.6429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarageFilledIcon);
export default __webpack_public_path__ + "static/media/garage-filled-icon.f21c078a27963bf962ede5a56699fb5e.svg";
export { ForwardRef as ReactComponent };